import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { clsx } from '../clsx';
import styles from './RadioCard.module.css';

export interface RadioCardProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'title'> {
  title: string;
  /** Second line, 11.5 px muted ("Setter rufen an"). */
  description?: ReactNode | undefined;
}

/** Selectable card with radio ("Nächster Schritt", "Neuer Status"): accent-soft fill and accent border when checked. */
export const RadioCard = forwardRef<HTMLInputElement, RadioCardProps>(function RadioCard(
  { title, description, className, ...rest },
  ref,
) {
  return (
    <label className={clsx(styles.card, className)}>
      <input ref={ref} type="radio" className={styles.input} {...rest} />
      <span className={styles.circle} aria-hidden="true" />
      <span className={styles.text}>
        <span className={styles.title}>{title}</span>
        {description ? <span className={styles.description}>{description}</span> : null}
      </span>
    </label>
  );
});
